import { FC, ImgHTMLAttributes, ReactNode } from 'react';

import './FullPageMessage.scss';

interface IFullPageMessageProps {
  title: string;
  body?: ReactNode;
  imgProps?: ImgHTMLAttributes<HTMLImageElement>;
}
const FullPageMessage: FC<IFullPageMessageProps> = ({ title, body, imgProps }) => {
  return (
    <div className="full-page-message">
      {imgProps && (
        <img
          className="full-page-message__image theme-dark-rounded-image"
          alt={title}
          {...imgProps}
        />
      )}
      {title && <h2 className="full-page-message__title">{title}</h2>}
      {body && <p className="full-page-message__body">{body}</p>}
    </div>
  );
};

export default FullPageMessage;
